<template>
  <section>
    <section v-if="professionals">
      <div class="row my-4" v-if="professionals.length === 0">
        <div class="col-12 text-center">
          <div>
            <i class="far fa-frown fa-6x"></i>
          </div>
          <div class="mt-4">
            ขออภัยค่ะ แคมเปญนี้สงวนสิทธิ์สำหรับลูกค้าที่เคยใช้บริการ BeNeat มาแล้วอย่างน้อย 1 ครั้งค่ะ<br>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 col-lg-6 offset-lg-3 text-center">
            <img src="https://beneat.co/images/facebook_campaign_sep_2020.jpg"
                 alt=""
                 class="img-fluid">
          </div>
          <div class="col-12 col-lg-6 offset-lg-3">
            <div class="my-4">
              <h3>สาวก Facebook & Twitter ฟังทางนี้!!!</h3>
              <p>รับ Coins ฟรี 30 บาท ทันที ไม่ต้องลุ้น สามารถนำไปใช้เป็นส่วนลดได้กับทุกบริการของเรา เพียงแนะนำคุณแม่บ้าน BeNeat ที่คุณชื่นชอบ</p>
              <p>*เพื่อสิทธิ์ของท่าน กรุณาอย่าเปลี่ยนแปลงข้อความในส่วนของลิงค์ และ # แฮซแทก นะคะ สามารถบอกต่อความประทับใจได้ทั้ง 2 ช่องทาง</p>
              <p>จำกัด ช่องทางละ 1 สิทธิ์/ User เท่านั้น</p>
              <p>ร่วมกิจกรรมได้ตั้งแต่วันนี้ – 30 กันยายน 2563 นี้นะคะ</p>
            </div>
          </div>
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="col-md-4 col-12" v-for="(professional, index) in professionals" :key="index">
            <a href="" class="no-style" @click.prevent="openFacebookDialog(professional.id)">
              <div class="card shadow-sm">
                <div class="card-body">
                  <div class="row">
                    <div class="col-2 p-0">
                      <professional-picture :professional="professional"
                                            :imgClass="'img-fluid'"
                                            :imgSize="40"/>
                    </div>
                    <div class="col-10">
                      <h3 class="mb-1">{{ professional.name | firstName }}</h3>
                      <div class="professional-city">
                        {{ globalState.cities[professional.province_id] | multiLangName }}
                      </div>
                      <div class="mt-3">
                        <i class="fas fa-star -rating-star"></i> {{ professional.rating.toFixed(1) }}
                        &nbsp;{{ $tc('message.professional.bookings', Number(professional.booking_qty)) }}: {{
                        professional.booking_qty }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card -->
            </a>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </section>
    <section v-else>
      <loader/>
    </section>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../loader/Loader'
  import ProfessionalPicture from './../professional/components/ProfessionalPicture'

  export default {
    components: {
      Loader,
      ProfessionalPicture
    },
    data () {
      return {
        queryData: {
          page: 0,
          user_id: null,
          status: 'previous'
        }
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        isLoadMore: 'user/isLoadMore',
        professionals: 'user/getProfessionals',
        state: 'user/getState'
      })
    },
    methods: {
      loadFirstPage () {
        this.queryData.page = 0
        this.$store.dispatch('user/LOAD_PROFESSIONAL_LIST', this.queryData)
      },
      loadMore () {
        this.queryData.page++
        this.$store.dispatch('user/LOAD_PROFESSIONAL_LIST', this.queryData)
      },
      openFacebookDialog (profId) {
        window.FB.ui({
          method: 'share',
          href: 'https://beneat.co/cleaner/' + profId
        }, (response) => {
          if (!response) {
            console.log('User did not share the page.')
          } else {
            console.log('User shared the page!')
            // Set earning coins condition here
            const submitData = {
              user_id: this.$route.query.user_id,
              social_data: ' Earn credits from sharing facebook on 16 - 30 Sep | prof_id:' + profId
            }
            this.$store.dispatch('socialCampaign/SAVE_FACEBOOK_COINS', submitData)
          }
        })
      }
    },
    mounted () {
      this.$store.commit('user/SET_NO_DATA')
      if (this.$route.query.user_id) {
        this.queryData.user_id = this.$route.query.user_id
      }
      this.loadFirstPage()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/social/FacebookPost.vue